<template>
  <div>
    <b-container fluid>
      <b-row class="mb-2">
        <b-col cols="12" md="6" class="mb-2">
          <v-selectpage
            :data="courses"
            placeholder="Derslerinizi Seçin"
            key-field="id"
            @values="add"
            show-field="code"
            title="Dersler"
            :multiple="true"
            :tb-columns="columns"
            ref="sp"
            language="en"
          ></v-selectpage
        ></b-col>
        <b-col cols="12" md="2" class="text-center mb-2"
          ><b-button
            variant="primary"
            class="ml-2 mr-2 mb-2"
            @click="findSchedules"
            >Olası Programları Bul</b-button
          ><b-button variant="danger" class="ml-2 mr-2 mb-2" @click="clear"
            >Hepsini Temizle</b-button
          ></b-col
        >
        <b-col cols="12" md="2" class="mb-2">
          <v-selectpage
            :data="days"
            placeholder="Boş Olmasını İstediğiniz Günlerinizi Seçin"
            key-field="day"
            @values="addDay"
            show-field="day"
            title="Günler"
            :multiple="true"
            :tb-columns="columnsDay"
            :pagination="false"
            language="en"
          >
          </v-selectpage
        ></b-col>
        <b-col cols="12" md="2" class="mb-2">
          <v-selectpage
            :data="hours"
            placeholder="Boş Olmasını İstediğiniz Saatlerinizi Seçin"
            key-field="hour"
            @values="addHour"
            show-field="hour"
            title="Saatler"
            :multiple="true"
            :tb-columns="columnsHour"
            :pagination="false"
            language="en"
          >
          </v-selectpage
        ></b-col>
      </b-row>

      <b-row v-if="selectedCourses.length > 0" class="mb-2">
        <b-col cols="12" class="mb-2">
          <h4 class="text-dark text-center">Alınan Dersler</h4>
        </b-col>
        <b-col cols="12">
          <b-table
            id="selected-table"
            :fields="selectedFields"
            :items="selectedCourses"
            :per-page="perPage"
            :current-page="currentPage"
            striped
            bordered
            hover
            small
            responsive
          >
            <!-- A custom formatted data column cell -->
            <template #cell(actions)="data">
              <b-button variant="danger" @click="remove(data.index)"
                ><b-icon icon="x-lg"></b-icon
              ></b-button>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="selected-table"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-row v-if="length != null">
        <b-col cols="12" class="mb-2">
          <h4 class="text-dark text-center">Varyasyonlar</h4>
        </b-col>
        <b-col cols="12" class="text-center mb-4">
          <h6 v-if="length > 0">Olası {{ length }} program var.</h6>

          <h6 v-if="length == 0">Olası bir program yok.</h6>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="mb-2"
          id="scroll-list"
          v-for="(comb, index) in loadedCombinations"
          :key="index"
        >
          <div class="text-center mb-4">
            <h4>Varyasyon #{{ index + 1 }}</h4>
            <b-button
              variant="danger"
              class="mt-2"
              @click="generateReport(index)"
              >PDF Olarak İndir</b-button
            >
          </div>
          <b-table
            id="table"
            :fields="fields"
            :items="comb"
            striped
            bordered
            hover
            small
            responsive
          >
            <template #cell()="data">
              <div
                v-if="data.value.name.length > 0"
                :style="{
                  'background-color': data.value.color,
                  'border-radius': '5px',
                  color: 'white',
                }"
                v-text="data.value.name"
              ></div>
            </template>
          </b-table>

          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1500"
            :filename="'IEU Program - #' + (index + 1)"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="landscape"
            pdf-content-width="100%"
            :ref="'html2Pdf-' + index"
          >
            <section slot="pdf-content">
              <b-navbar :style="{ backgroundColor: '#f5f5f5' }" class="mb-4">
                <b-navbar-brand>
                  <h4 class="text-dark">
                    IEU <span class="font-weight-light"> PROGRAM BULUCU </span>
                    <span
                      class="font-weight-light"
                      :style="{ backgroundColor: '#4caf50' }"
                      >(2025-2026 GÜZ)</span
                    >
                  </h4>
                </b-navbar-brand>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <h5 class="text-dark">Ercan Acar</h5>
                </b-navbar-nav>
              </b-navbar>
              <h5 class="text-center mt-3 mb-4">Varyasyon #{{ index + 1 }}</h5>
              <b-table
                id="table"
                :fields="fields"
                :items="comb"
                striped
                bordered
                hover
                small
                responsive
              >
                <template #cell()="data">
                  <div
                    v-if="data.value.name.length > 0"
                    :style="{
                      'background-color': data.value.color,
                      'border-radius': '5px',
                      color: 'white',
                    }"
                    v-text="data.value.name"
                  ></div>
                </template>
              </b-table>
            </section>
          </vue-html2pdf>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import courseList from "./courses.js";

export default {
  data() {
    return {
      courses: courseList.courses,
      columns: [
        { title: "Ders Kodu", data: "code" },
        // { title: "Ders Adı", data: "course" },
        // { title: "Öğretim Üyesi", data: "instructor" },
        { title: "Grup", data: "group" },
        // { title: "Akts", data: "akts" },
        { title: "Gün - Saat - Sınıf", data: "day" },
        { title: "Veriliş Şekli", data: "type" },
      ],
      perPage: 5,
      currentPage: 1,
      selectedFields: [
        { key: "code", label: "Ders Kodu" },
        // { key: "course", label: "Ders Adı" },
        // { key: "instructor", label: "Öğretim Üyesi" },
        { key: "type", label: "Veriliş Şekli" },
        { key: "group", label: "Grup" },
        // { key: "akts", label: "Akts" },
        { key: "day", label: "Gün - Saat - Sınıf" },
        { key: "actions", label: "Eylemler" },
      ],
      fields: [
        {
          key: "0",
          label: "Saat",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "1",
          label: "Pazartesi",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "2",
          label: "Salı",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "3",
          label: "Çarşamba",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "4",
          label: "Perşembe",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "5",
          label: "Cuma",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "6",
          label: "Cumartesi",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "7",
          label: "Pazar",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      selectedCourses: [],
      combinations: [],
      loadedCombinations: [],
      length: null,
      nextItem: 1,
      hoursArray: [
        { 0: { name: "08:30-09:15", color: "#7f8c8d" } },
        { 0: { name: "09:25-10:10", color: "#7f8c8d" } },
        { 0: { name: "10:20-11:05", color: "#7f8c8d" } },
        { 0: { name: "11:15-12:00", color: "#7f8c8d" } },
        { 0: { name: "12:10-12:55", color: "#7f8c8d" } },
        { 0: { name: "13:05-13:50", color: "#7f8c8d" } },
        { 0: { name: "14:00-14:45", color: "#7f8c8d" } },
        { 0: { name: "14:55-15:40", color: "#7f8c8d" } },
        { 0: { name: "15:50-16:35", color: "#7f8c8d" } },
        { 0: { name: "16:45-17:30", color: "#7f8c8d" } },
        { 0: { name: "17:40-18:25", color: "#7f8c8d" } },
        { 0: { name: "18:35-19:20", color: "#7f8c8d" } },
        { 0: { name: "19:30-20:15", color: "#7f8c8d" } },
        { 0: { name: "20:25-21:10", color: "#7f8c8d" } },
        { 0: { name: "21:20-22:05", color: "#7f8c8d" } },
        { 0: { name: "22:15-23:00", color: "#7f8c8d" } },
      ],
      days: [
        {
          day: "Pazartesi",
          time: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
        },
        {
          day: "Salı",
          time: [
            17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
          ],
        },
        {
          day: "Çarşamba",
          time: [
            33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
          ],
        },
        {
          day: "Perşembe",
          time: [
            49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64,
          ],
        },
        {
          day: "Cuma",
          time: [
            65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
          ],
        },
        {
          day: "Cumartesi",
          time: [
            81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96,
          ],
        },
        {
          day: "Pazar",
          time: [
            97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110,
            111, 112,
          ],
        },
      ],
      hours: [
        { hour: "08:30-09:15", time: [1, 17, 33, 49, 65, 81, 97] },
        { hour: "09:25-10:10", time: [2, 18, 34, 50, 66, 82, 98] },
        { hour: "10:20-11:05", time: [3, 19, 35, 51, 67, 83, 99] },
        { hour: "11:15-12:00", time: [4, 20, 36, 52, 68, 84, 100] },
        { hour: "12:10-12:55", time: [5, 21, 37, 53, 69, 85, 101] },
        { hour: "13:05-13:50", time: [6, 22, 38, 54, 70, 86, 102] },
        { hour: "14:00-14:45", time: [7, 23, 39, 55, 71, 87, 103] },
        { hour: "14:55-15:40", time: [8, 24, 40, 56, 72, 88, 104] },
        { hour: "15:50-16:35", time: [9, 25, 41, 57, 73, 89, 105] },
        { hour: "16:45-17:30", time: [10, 26, 42, 58, 74, 90, 106] },
        { hour: "17:40-18:25", time: [11, 27, 43, 59, 75, 91, 107] },
        { hour: "18:35-19:20", time: [12, 28, 44, 60, 76, 92, 108] },
        { hour: "19:30-20:15", time: [13, 29, 45, 61, 77, 93, 109] },
        { hour: "20:25-21:10", time: [14, 30, 46, 62, 78, 94, 110] },
        { hour: "21:20-22:05", time: [15, 31, 47, 63, 79, 95, 111] },
        { hour: "22:15-23:00", time: [16, 32, 48, 64, 80, 96, 112] },
      ],
      colors: [
        "#3498db",
        "#4d4dff",
        "#a52a2a",
        "#8080ff",
        "#008b8b",
        "#bdb76b",
        "#ff4dff",
        "#556b2f",
        "#ff8c00",
        "#9932cc",
        "#e9967a",
        "#9400d3",
        "#ff00ff",
        "#ffd700",
        "#008000",
        "#aa33ff",
        "#e5d334",
        "#4fabc9",
        "#38e038",
        "#ffb6c1",
        "#2ecc71",
        "#808000",
        "#ffa500",
        "#ffc0cb",
        "#ff4d4d",
        "#f1c40f",
      ],
      columnsDay: [{ title: "Gün", data: "day" }],
      columnsHour: [{ title: "Saat", data: "hour" }],
      selectedDays: [],
      selectedHours: [],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
    this.makeToast();
  },
  computed: {
    rows() {
      return this.selectedCourses.length;
    },
  },
  methods: {
    findSchedules() {
      let arrayOfPossibilities = [];
      let arrayOfLessons = [];
      let arrayOfAddedLessons = [];
      this.combinations = [];
      this.loadedCombinations = [];
      this.length = null;
      this.nextItem = 1;

      function arraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
          return false;
        }

        return JSON.stringify(arr1.sort()) === JSON.stringify(arr2.sort());
      }

      this.selectedCourses.forEach((element) => {
        if (!arrayOfLessons.includes(element.code) && element.time.length > 0) {
          arrayOfLessons.push(element.code);
        }

        element.seen = false;
      });

      for (let i = 0; i < this.selectedCourses.length; i++) {
        let dummy = [];

        for (let j = 0; j < this.selectedCourses.length; j++)
          if (
            this.selectedCourses[i].code == this.selectedCourses[j].code &&
            this.selectedCourses[j].time.length > 0 &&
            this.selectedCourses[j].seen == false
          ) {
            this.selectedCourses[j].seen = true;

            if (
              (!this.selectedDays.length ||
                (this.selectedDays.length > 0 &&
                  !this.selectedCourses[j].time.some((v) =>
                    this.selectedDays.includes(v)
                  ))) &&
              (!this.selectedHours.length ||
                (this.selectedHours.length > 0 &&
                  !this.selectedCourses[j].time.some((v) =>
                    this.selectedHours.includes(v)
                  )))
            ) {
              if (
                !arrayOfAddedLessons.includes(this.selectedCourses[j].code) &&
                this.selectedCourses[j].time.length > 0
              ) {
                arrayOfAddedLessons.push(this.selectedCourses[j].code);
              }
              dummy.push(j);
            }
          }
        if (dummy.length > 0) {
          arrayOfPossibilities.push(dummy);
        }
      }

      if (
        !arraysEqual(arrayOfLessons, arrayOfAddedLessons) ||
        arrayOfAddedLessons.length == 0
      ) {
        this.length = 0;
      }

      function getCombinations(allOptionsArray, combination) {
        if (allOptionsArray.length > 0) {
          for (var i = 0; i < allOptionsArray[0].length; i++) {
            var tmp = allOptionsArray.slice(0);
            combination.codes[combination.counter] = allOptionsArray[0][i];
            tmp.shift();
            combination.counter++;
            getCombinations(tmp, combination);
          }
        } else {
          var combi = combination.codes.slice(0);
          combination.result.push(combi);
        }
        combination.counter--;
      }

      function getRandomColor(array, colors) {
        var found = true;
        while (found) {
          var r = Math.floor(Math.random() * colors.length);
          if (array.indexOf(r) === -1) {
            array.push(r);
            found = false;
            return colors[r];
          }
        }
      }

      if (this.length != 0) {
        var combination = { codes: [], result: [], counter: 0 };

        getCombinations(arrayOfPossibilities, combination);

        const R = this.hoursArray.length,
          C = 7;
        const val = { name: "", color: "" };

        for (let i = 0; i < combination.result.length; i++) {
          var finalArray = [];
          var tempArray = [];
          var tempColorArray = [];

          var emptyArray = Array(R)
            .fill()
            .map(() => {
              const data = {};
              for (let k = 1; k < C + 1; ++k) data[k] = val;
              return data;
            });

          var result = this.hoursArray.map((item, index) => {
            return { ...item, ...emptyArray[index] };
          });

          for (let j = 0; j < combination.result[i].length; j++) {
            var courseId = combination.result[i][j];
            tempArray.push(this.selectedCourses[courseId].time);
            var tempColor = getRandomColor(tempColorArray, this.colors);

            for (
              let k = 0;
              k < this.selectedCourses[courseId].time.length;
              k++
            ) {
              var time = this.selectedCourses[courseId].time[k];
              var column =
                time % this.hoursArray.length == 0
                  ? this.hoursArray.length - 1
                  : (time % this.hoursArray.length) - 1;
              var row = Math.ceil(time / this.hoursArray.length);

              result[column][row] = {
                name:
                  this.selectedCourses[courseId].code +
                  " - " +
                  this.selectedCourses[courseId].group,
                color: tempColor,
              };
            }
          }

          finalArray.push(tempArray);
          let tempCombination = finalArray.flat(2);
          let set = new Set(tempCombination);
          if (tempCombination.length === set.size) {
            this.combinations.push(result);
          }
        }

        this.length = this.combinations.length;
        this.combinations = this.paginate(this.combinations, 6);
        this.loadedCombinations = this.combinations[0];
      }
    },
    clear() {
      this.selectedCourses = [];
      this.combinations = [];
      this.loadedCombinations = [];
      this.length = null;
      this.nextItem = 1;
      this.$refs.sp.remove();
    },
    add(data) {
      this.selectedCourses = data;
    },
    addDay(data) {
      this.selectedDays = [];
      data.map((x) => this.selectedDays.push(x.time));
      this.selectedDays = this.selectedDays.flat();
    },
    addHour(data) {
      this.selectedHours = [];
      data.map((x) => this.selectedHours.push(x.time));
      this.selectedHours = this.selectedHours.flat();
    },
    remove(index) {
      this.$refs.sp.remove(index);
      this.findSchedules();
    },
    paginate(array, n) {
      const pageSize = Math.ceil(array.length / n);

      return Array.from({ length: pageSize }, (_, index) => {
        const start = index * n;
        return array.slice(start, start + n);
      });
    },
    loadMore() {
      if (
        window.scrollY + window.innerHeight >=
          document.body.scrollHeight - 200 &&
        this.combinations.length > this.nextItem
      ) {
        this.loadedCombinations = this.loadedCombinations.concat(
          this.combinations[this.nextItem++]
        );
      }
    },
    generateReport(index) {
      this.$refs["html2Pdf-" + index][0].generatePdf();
    },
    makeToast() {
      this.$bvToast.toast("@ercanacar1 Takip etmeyi unutmayın :)", {
        href: "https://www.instagram.com/ercanacar1",
        title: "Hoş Geldiniz!",
        variant: "success",
        autoHideDelay: 5000,
        solid: true,
      });
    },
  },
};
</script>

<style>
</style>